import { StringsEnumDimension } from '@orus.eu/dimensions'
import { mrpwProductVersions } from '@orus.eu/product'

export const mrpwVersionDimension = new StringsEnumDimension({
  name: 'mrpwVersion',
  displayKeys: { name: 'dimension_name_mrpw_version' },
  values: mrpwProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export { type MrpwVersion } from '@orus.eu/product'
